module.exports = __webpack_public_path__ + "img/o.77872243.jpg";